// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__HWDNk","buttons":"PendingPaymentAlert_buttons__w5QHZ"};